<template>
  <section
    class="marketing-container"
    @click="is_select = false"
  >
    <div class="flex-sb-center mg-b-30">
      <div>
        <v-button
          gray
          stop
          @click="handleSelect">{{selectName}}
          <i
            class="el-icon-caret-bottom"></i>
        </v-button>
        <v-select-list
          v-model="is_select"
          :list="reportList"
          @select="handlePath"
        ></v-select-list>
      </div>
      <div>
        <v-button
          gray
          @click="handleExportList">Export List</v-button>
        <v-button
          gray
          @click="handleExport">Export</v-button>
      </div>

    </div>
    <router-view
      ref="child"
      class="child"></router-view>
  </section>
</template>

<script>
import MixinOption from '@/mixins/options'

export default {
  name: 'index',
  mixins:[MixinOption],
  data(){
    return{
      is_select:false
    }
  },
  computed:{
    selectName(){
      let path = this.$route.path
      let arr = path.split('/')
      let last = arr[arr.length - 1]
      let result = ''
      this.reportList.some(item=>{
        let {list} = item||{}
        list.some(content=>{
          let {path} = content||{}
          if(path.indexOf(last)!==-1){
            result = content.name
            return true
          }
          return false
        })
        return result
      })
      return result

    }
  },
  methods:{
    handleExportList(){
      this.$router.push({
        path:'/admin-cms/marketing-report',
        query:{
          name:'list'
        }
      })
    },
    handleExport(){
      this.$refs.child.exportList()
    },
    handleSelect(){
      this.is_select = !this.is_select
    },
    handlePath({path}){
      this.is_select = false
      this.$router.push(path)
    }
  }
}
</script>

<style scoped lang="scss">
.marketing-container{
  .mg-b-30{
    margin-bottom: 30px;
  }
}
</style>
